<template>
  <div class="container">
    <img :src="logo" alt="" class="logo">
    <div class="slogan">
      以“按需用工+零客经济”产业互联网承包经营与结算为核心场景，聚焦灵活用工领域，打造“智能结算+合规财税+数字风控”三位一体的SaaS平台，为企业提供任务发布、自由职业者匹配、实时结算、合规报税及完税凭证等全闭环服务。
    </div>
    <div class="tips">
      <p>TO PAY TAXES ACCORDING TO LAW</p>
      <p>依法诚信纳税是中国公民的义务</p>
    </div>

  </div>
</template>
<script>
export default {
  name: 'about',
  data () {
    return {
      logo: require('@/assets/logo.png'),
      text: ''
    }
  },
  methods: {

  }

}
</script>
<style scoped>
.container {
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 60px;
}

.logo {
  display: block;
  width: 240px;
  height: auto;
  margin: 120px auto 0;
  object-fit: contain;
}

.slogan {
  margin: 48px auto 80px;
  padding: 0 40px;
  font-size: 30px;        /* 正文，可再调到 32 */
  line-height: 1.8;
  text-indent: 2em;
  color: #333;
  text-align: justify;
}

.tips {
  font-size: 24px;        /* 底部提示，可再调到 26 */
  color: #cfcfcf;
  text-align: center;
  line-height: 1.9;
}
</style>
